module.exports = __webpack_public_path__ + "img/vote-yea.793e8efc.svg";